import { clipLogHttpClient } from "./createClipLogHttpClient";

export const postLogReport = async <T>(data: unknown) => {
  return clipLogHttpClient.request<T>({
    method: "POST",
    url: "/api/log",
    body: data,
  });
};
